import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback, useEffect, useState } from 'react';

/**
 * A Direct Sale Line is only linked to the Program Products it qualified for through the Dir Sale
 * Line Prog Prod records the md module writes, so the matched Program Product ids are resolved first
 * and then used to filter the Program Products.
 */
export const DirSaleLineProgProdList = ({ dirSaleLineId }) => {
  const rsrc = useRsrc();
  const [progProdIds, setProgProdIds] = useState(null);

  useEffect(() => {
    let active = true;

    rsrc
      .rows('sc', 'DIR_SALE_LINE_PROG_PROD', { expr: ExprUtils.whereParams('dirSaleLineId', dirSaleLineId) })
      .then((rows) => {
        if (active) setProgProdIds(rows.map((row) => row.progProdId));
      });

    return () => {
      active = false;
    };
  }, [dirSaleLineId, rsrc]);

  const augRowsReq = useCallback(
    (rowsReq) => {
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.setExpr('id', progProdIds));
    },
    [progProdIds],
  );

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  };

  if (progProdIds == null) return null;

  return <EntityList module="md" entity="PROG_PROD" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
